var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c(_vm.titleTag,{tag:"component",class:_vm.className},[(_vm.isDangerous)?_c('a-dangerous-html',{attrs:{"content":_vm.title}}):[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }